import get from 'lodash/get';
import {useAppDispatch} from '../../app/hooks/useAppDispatch';
import {useAppSelector} from '../../app/hooks/useAppSelector';
import {selectSessionData, setSessionData} from './authSlice';
import {useCallback} from 'react';

export const useSessionState = (key: string): [unknown, (value: unknown) => void] => {
  const dispatch = useAppDispatch();
  const sessionData = useAppSelector(selectSessionData);
  const value = sessionData ? get(sessionData, key) : null;
  const setValue = useCallback(
    (value: unknown) => {
      dispatch(setSessionData({key, value}));
    },
    [dispatch, key],
  );

  return [value, setValue];
};
